import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, WizardServiceLocator, DialogService } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { TerminalTruckRegistration, TerminalTruckRegistrationResult } from '../../model/terminal/truck-registration.model';
import { PageCall } from '@sdbn/tmc-common';

export class TruckRegistrationSendDataToBackendController extends AbstractStepController {

    errorOccured = false;

    appServerAPI: AppServerAPI;

    constructor() {
        super();
        this.appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {
    }

    public handleFlow(): FlowStepHandleResult {
        const result = new FlowStepHandleResult();
        result.type = HandleResultType.PROCESSING;

        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('send data to backend started');

        this.saveRegistrationAndShowFinishPage();

        return result;
    }

    getControls(): StepControl[] {
        const controls = new Array<StepControl>();
        return controls;
    }


    private saveRegistrationAndShowFinishPage(): Promise<void> {
        this.dashboardContext.setContextValue(TerminalContextConstants.registrationFinished, new Date().getTime());
        return this.saveMasterData()
            .then(() => {
                // Finally call next Wizard Step
                if (!this.errorOccured) {
                    this.wizardComponent.next();
                }
            });
    }


    private saveMasterData() {

        const dto = new TerminalTruckRegistration();
        // Terminal identifier setzen
        dto.terminalIdentifier = this.dashboardContext.getContextValue('terminalIdentifier');
        dto.carrier = this.dashboardContext.getContextValue(TerminalContextConstants.carrier);
        dto.coDriver = this.dashboardContext.getContextValue(TerminalContextConstants.coDriver);
        dto.driver = this.dashboardContext.getContextValue(TerminalContextConstants.driver);
        dto.supplier = this.dashboardContext.getContextValue(TerminalContextConstants.supplier);
        dto.numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
        dto.gcCaseId = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseId);
        dto.gcCaseUrl = this.dashboardContext.getContextValue(TerminalContextConstants.gcCaseUrl);
        dto.useGlobalConnect = this.dashboardContext.getContextValue('useGlobalConnect') === true;
        dto.messagingLanguage = this.dashboardContext.getContextValue(TerminalContextConstants.language);

        const logContainer: LogContainer = this.dashboardContext.getContextValue(TerminalContextConstants.logContainer);

        for (const logEntry of logContainer.logEntries) {
            dto.pageCalls.push(new PageCall({ key: logEntry.message, timestamp: logEntry.timestamp }));
        }

        dto.registrationId = this.dashboardContext.getContextValue(TerminalContextConstants.registrationId);
        dto.registrationFinished = this.dashboardContext.getContextValue(TerminalContextConstants.registrationFinished);
        dto.registrationStarted = this.dashboardContext.getContextValue(TerminalContextConstants.registrationStarted);

        dto.smartphoneCommunicationEnabled = this.dashboardContext.getContextValue('smartphoneConnectionEnabled') === true;
        dto.smartphoneConnected = this.dashboardContext.getContextValue(TerminalContextConstants.smartphoneConnected) === true;
        dto.smartphoneRequired = this.dashboardContext.getContextValue(TerminalContextConstants.driverCommunication)
            === TerminalContextConstants.DRIVER_COMMUNICATION_LOANER;

        console.log('save master data ', dto);

        return this.appServerAPI.execute(`/terminal/registration/finish/truck`, dto)
            .toPromise()
            .then(response => {
                console.log('saveMasterData call succeeded:', response);
                // We update the registrationId
                const terminalRegistrationResult = new TerminalTruckRegistrationResult(response);
                const registrationId = terminalRegistrationResult.registrationId;
                this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registrationId);
                const gatekeeperMandatory = terminalRegistrationResult.gatekeeperMandatory;
                this.dashboardContext.setContextValue(TerminalContextConstants.gatekeeperMandatory, gatekeeperMandatory);
            }, error => {
                console.log('saveMasterData call failed:', error);
                this.showHttpError();
            });
    }

    private showHttpError() {
        this.errorOccured = true;

        const matDialog = WizardServiceLocator.injector.get(DialogService);
        matDialog.showInfoDialog(
            'tmc-yard.ui.registration-terminal.registration-failed-title',
            'tmc-yard.ui.registration-terminal.registration-failed-message'
        ).afterClosed().subscribe(
            () => this.wizardComponent.restartWizard()
        );
    }
}
